import axios from 'axios';
import { useAuthStore } from '@/store/AuthStore';

interface ApiResponse {
    //TODO: Define ApiResponse structure
}
// Create an Axios instance
const apiClient = axios.create({
    baseURL: process.env.VUE_APP_API_URL || 'http://localhost:4000/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor to include the JWT token in headers
apiClient.interceptors.request.use(
    (config) => {
        const authStore = useAuthStore();
        const token = authStore.token; // Access the token from the auth store
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`; // Attach token to the headers
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default apiClient;